import {Item, Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import {PortalActionEvent} from "./PortalActionEvent";

export enum PortalItemPosition {
	End = "end",
	Before = "before",
	Inplace = "inplace",
	After = "after"
}

export class PortalItem extends Item implements Parameter {
	public position?: PortalItemPosition;

	constructor(data: any) {
		super(data);

		this.position = FunctionHelper.exists(data?.position) ? data.position : PortalItemPosition.End;
		this.actions = FunctionHelper.applyValue(
			data.actions, Item.getActionsDefault()
		).map(PortalActionEvent.fromJson);
	}

	public static getPositionDefault(): PortalItemPosition {
		return PortalItemPosition.End;
	}

	public static fromJson(data: any): PortalItem {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalItem(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'position': this.position,
		};
	}

	public clone(): PortalItem {
		return PortalItem.fromJson(this.toJson());
	}
}